<template>
	<section id="servicios" ref="servicios" class="white">
		<v-container fluid fill-height class="container py-15">
			<v-row justify="center" align="center" class="py-5">
				<v-col align="center" cols="11" md="5">
					<h3 v-scrollanimation class="anim texto font-weight-light primary--text">
						{{ $t('servicios.definicion') }}
					</h3>
				</v-col>

				<v-col md="9">
					<v-row align="start" justify="center">
						<v-col align="center" xl="3" lg="3" md="4" v-for="(card, i) in slides" :key="i">
							<v-hover v-slot="{ hover }">
								<v-card
									height="100%"
									class="card ma-md-5 rounded-xl card-outter"
									color="azulFondo"
									max-width="300"
									min-width="225"
									min-height="390"
									max-height="500"
									:elevation="hover ? 10 : 5"
									outlined
								>
									<v-img :src="card.img" max-height="220" class="pa-5">
										<v-card-text>
											<v-avatar size="100" class="py-15 my-10" tile>
												<v-img :src="card.icon" contain> </v-img>
											</v-avatar>
										</v-card-text>
									</v-img>
									<v-card-title id="title" class="text-h5 neftysBlue--text justify-center ow-break-word">
										{{ $t(`${card.title}`) }}
									</v-card-title>
									<v-card-subtitle> </v-card-subtitle>

									<!-- <v-row align="start" justify="center" class="mt-0">
                    <v-col>
                      <v-card-subtitle class="primary--text text-start pb-0">
                        {{ $t(`${card.subtitle}`) }}
                      </v-card-subtitle>
                    </v-col>
                  </v-row> -->

									<v-card-actions class="card-actions">
										<v-btn color="accent" @click="card.reveal = true" fab elevation="0">
											<v-icon>mdi-chevron-up</v-icon>
										</v-btn>
									</v-card-actions>

									<v-expand-transition>
										<v-card
											height="100%"
											v-if="card.reveal"
											class="transition-fast-in-fast-out v-card--reveal rounded-xl neftysGradientHard"
											color="accent"
										>
											<v-card-text style="height: 100%" class="pb-0">
												<v-list class="transparent py-0">
													<v-list-item v-for="(item, i) in card.list_items" :key="i">
														<v-list-item-icon>
															<v-icon color="white">mdi-check-bold</v-icon>
														</v-list-item-icon>

														<v-list-item-content>
															<v-sheet
																color="transparent"
																class="d-flex text-left body-1 white--text list"
															>
																{{ $t(`${item.title}`) }}
															</v-sheet>
														</v-list-item-content>
													</v-list-item>
												</v-list>

												<v-btn v-if="card.catalogo" target="_blank" href="https://pets.soladomingo.com">
													{{ $t('info.catalogo') }}
												</v-btn>
											</v-card-text>

											<v-divider></v-divider>

											<v-card-actions class="d-flex justify-center">
												<v-btn
													color="amarillo"
													@click="card.reveal = false"
													absolute
													bottom
													right
													icon
												>
													<v-icon class="white--text">mdi-chevron-down</v-icon>
												</v-btn>
											</v-card-actions>
										</v-card>
									</v-expand-transition>
								</v-card>
							</v-hover>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</v-container>
	</section>
</template>

<script>
export default {
	name: 'Servicios',
	data: () => ({
		slides: [
			{
				img: require('@/assets/img/neftys/cards/7.jpg'),
				title: 'servicios.accesorios',
				icon: require('@/assets/icon/servicios/accesorios.svg'),
				list_items: [
					{ title: 'servicios.accesorios1' },
					{ title: 'servicios.accesorios2' },
					{ title: 'servicios.accesorios3' },
					{ title: 'servicios.accesorios4' },
					{ title: 'servicios.accesorios5' },
				],
				reveal: false,
				catalogo: true,
			},
			{
				img: require('@/assets/img/neftys/cards/12.jpg'),
				title: 'servicios.auditorias',
				icon: require('@/assets/icon/servicios/auditoria2.svg'),
				list_items: [
					{ title: 'servicios.auditorias1' },
					{ title: 'servicios.auditorias2' },
					{ title: 'servicios.auditorias4' },
					{ title: 'servicios.auditorias3' },
					{ title: 'servicios.auditorias5' },
					{ title: 'servicios.auditorias6' },
				],
				reveal: false,
			},
			{
				img: require('@/assets/img/neftys/cards/9.jpg'),
				title: 'servicios.bioseguridad',
				icon: require('@/assets/icon/servicios/bioseguridad.svg'),
				list_items: [
					{ title: 'servicios.bioseguridad4' },
					{ title: 'servicios.bioseguridad1' },
					{ title: 'servicios.bioseguridad2' },
					{ title: 'servicios.bioseguridad3' },
				],
				reveal: false,
			},
			{
				img: require('@/assets/img/neftys/cards/10.jpg'),
				title: 'servicios.complementos',
				icon: require('@/assets/icon/servicios/complementos.svg'),
				list_items: [
					{ title: 'servicios.complementos2' },
					{ title: 'servicios.complementos3' },
					{ title: 'servicios.complementos4' },
					{ title: 'servicios.complementos1' },
					{ title: 'servicios.complementos6' },
				],
				reveal: false,
			},
			{
				img: require('@/assets/img/neftys/cards/5.jpg'),
				title: 'servicios.aguas',
				icon: require('@/assets/icon/servicios/aguas.svg'),
				list_items: [
					{ title: 'servicios.aguas5' },
					{ title: 'servicios.aguas3' },
					{ title: 'servicios.aguas1' },
					{ title: 'servicios.aguas2' },
					{ title: 'servicios.aguas4' },
				],
				reveal: false,
			},
			{
				img: require('@/assets/img/neftys/cards/11.jpg'),
				title: 'servicios.desparasitación',
				icon: require('@/assets/icon/servicios/insecticida.svg'),
				list_items: [
					{ title: 'servicios.desparasitación1' },
					{ title: 'servicios.desparasitación2' },
					{ title: 'servicios.desparasitación3' },
					{ title: 'servicios.desparasitación4' },
					{ title: 'servicios.desparasitación5' },
				],
				reveal: false,
			},
			{
				img: require('@/assets/img/neftys/cards/8.jpg'),
				title: 'servicios.digitalizacion',
				icon: require('@/assets/icon/servicios/digitalizacion.svg'),
				list_items: [
					{ title: 'servicios.digitalizacion6' },
					{ title: 'servicios.digitalizacion5' },
					{ title: 'servicios.digitalizacion1' },
					{ title: 'servicios.digitalizacion2' },
					{ title: 'servicios.digitalizacion4' },
				],
				reveal: false,
			},
			{
				img: require('@/assets/img/neftys/cards/2.jpg'),
				title: 'servicios.materialprofesional',
				icon: require('@/assets/icon/servicios/material.svg'),
				list_items: [
					{ title: 'servicios.materialprofesional3' },
					{ title: 'servicios.materialprofesional4' },
					{ title: 'servicios.materialprofesional2' },
					{ title: 'servicios.materialprofesional1' },
				],
				reveal: false,
			},
			{
				img: require('@/assets/img/neftys/cards/1.jpg'),
				title: 'servicios.medicamentos',
				icon: require('@/assets/icon/servicios/medicamentos.svg'),
				list_items: [
					{ title: 'servicios.medicamentos4' },
					{ title: 'servicios.medicamentos2' },
					{ title: 'servicios.medicamentos1' },
					{ title: 'servicios.medicamentos3' },
				],
				reveal: false,
			},

			{
				img: require('@/assets/img/neftys/cards/3.jpg'),
				title: 'servicios.normativa',
				icon: require('@/assets/icon/servicios/normativa.svg'),
				list_items: [
					{ title: 'servicios.normativa3' },
					{ title: 'servicios.normativa2' },
					{ title: 'servicios.normativa1' },
				],
				reveal: false,
			},
			{
				img: require('@/assets/img/neftys/cards/4.jpg'),
				title: 'servicios.nutricion',
				icon: require('@/assets/icon/servicios/nutricion.svg'),
				list_items: [
					{ title: 'servicios.nutricion5' },
					{ title: 'servicios.nutricion1' },
					{ title: 'servicios.nutricion3' },
					{ title: 'servicios.nutricion4' },
					{ title: 'servicios.nutricion2' },
				],
				reveal: false,
			},

			{
				img: require('@/assets/img/neftys/cards/6.jpg'),
				title: 'servicios.vacuna',
				icon: require('@/assets/icon/servicios/vacuna.svg'),
				list_items: [
					{ title: 'servicios.vacuna2' },
					{ title: 'servicios.vacuna4' },
					{ title: 'servicios.vacuna1' },
					{ title: 'servicios.vacuna3' },
				],
				reveal: false,
			},
		],
	}),
};
</script>

<style scoped>
.container {
	min-height: 100vh;
}

.ow-break-word {
	word-break: break-word;
}

.v-card--reveal {
	bottom: 0;
	opacity: 1 !important;
	position: absolute;
	width: 100%;
}

.before-enter.card {
	opacity: 0;
	transform: translateY(50px);
	transition: all 1s ease-in-out;
}
/* 
      Si el elemento se cruza con la ventana gráfica, se agrega la clase antes de ingresar.
    */
.enter.card {
	opacity: 1;
	transform: translateY(0px);
}

.before-enter g {
	stroke-dasharray: 915;
	stroke-dashoffset: 915;
}

.enter g {
	stroke-dasharray: 915;
	stroke-dashoffset: 0;
	transition: all 5s ease-in-out;
}

.card-outter {
	position: relative;
	padding-bottom: 50px;
}
.card-actions {
	position: absolute;
	bottom: 0;
	right: 0;
}

.neftysGradientHard {
  background: rgb(44,86,159);
  background: linear-gradient(131deg, #2c569f 50%, #099247 100%);
}

</style>
